import React from 'react';
import AppModal, { appModalStyles } from '../../../core/ui/app_modal';

export { appModalStyles };

export default function GatewayModal({ title, content, footer, size = 'default' }) {
  return (
    <AppModal title={title} size={size} allowClose={false} footer={footer} stackFooter={size === 'wide'}>
      {content}
    </AppModal>
  );
}
